import { useState } from "react";
import styles from "./PhoneInput.module.css";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Controller } from "react-hook-form";

type InputType = "text" | "password" | "email" | "number";

interface InputProps {
  type?: InputType;
  required?: boolean;
  register?: any;
  onChange?: any;
  inputId: string;
  label?: string;
  value?: string | undefined;
  placeholder?: string | null;
  labelfocus?: string;
  control?: any;
  disableDropdown?: boolean;
  setVal?: any;
  country?: string
}
export const CustomPhoneInput = ({
  type = "text",
  label,
  value = undefined,
  onChange = () => {},
  placeholder = null,
  required = false,
  labelfocus,
  control,
  country,
  disableDropdown,
  setVal = () => {},
}: InputProps) => {
  const [inputFocus, setInputFocus] = useState(false);

  return (
    <div className={styles.container}>
      {label && (
        <label>
          {label} {required && <span>*</span>}
        </label>
      )}
      {labelfocus && inputFocus && (
        <label>
          {labelfocus} {required && inputFocus && <span>*</span>}
        </label>
      )}

      <Controller
        control={control}
        name="phone"
        defaultValue={value}
        rules={{ required: true }}
        render={({ field: { ref, ...field } }) => (
          <ReactPhoneInput
            {...field}
            country={country || "ng"}
            onFocus={(e) => {
              e.target.placeholder = " ";
              setInputFocus(true);
            }}
            onBlur={(e: any) => {
              e.target.placeholder = `${placeholder}`;
              !e.target.value?.length && setInputFocus(false);
            }}
            onChange={(event) => {
              field.onChange(event);
              onChange(event);
              // value = event;
              setVal(event);
              // console.log(event.length, "value");
            }}
            disableDropdown={disableDropdown}
            enableLongNumbers={true}
            value={value}
          />
        )}
      />
    </div>
  );
};
